/* DeviceLicenseStatusRenderer.js */

"use strict";

class DeviceLicenseStatusColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("device-license-status-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("LicenseStatus", (this._onLicenseStatus = this._onLicenseStatus.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("LicenseStatus");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        return new Promise((resolve /*,reject*/) => {
            this._setLicenseStatus(this._model.getLicenseStatus());
            resolve();
        });
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onLicenseStatus(newVal) {
        this._setLicenseStatus(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setLicenseStatus(newVal = false) {
        if (newVal) {
            if (newVal) {
                this._rootElem.innerText = "Yes";
            } else {
                this._rootElem.innerText = "No";
            }
        } else {
            this._rootElem.innerHTML = "No";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = DeviceLicenseStatusColumnRenderer;
